import React from 'react';

import type { DynamicBlockElement, NonSigFieldElement } from '@aline/common';
import { Paper } from '@mui/material';
import type { NodeEntry } from 'slate';
import { defaultEditorPopoverPaperStyles } from 'src/components';
import { CompletedFieldPopoverContent, useGetFieldDetails } from 'src/editor/popovers/fields';
import { IncompleteVariablePopoverContent } from 'src/editor/popovers/fields/IncompleteVariablePopoverContent';
import { getWorkflowWasSentForSig } from 'src/workflow';

interface VariablePopoverContentProps {
  fieldEntry: NodeEntry<NonSigFieldElement | DynamicBlockElement>;
}

export function VariablePopoverContent({
  fieldEntry,
}: VariablePopoverContentProps): JSX.Element | null {
  const [fieldElement] = fieldEntry;
  const { document, field, showCompletedPopover } = useGetFieldDetails(fieldElement.fieldId);
  if (!document || !field || field.__typename === 'SignatureField') return null;

  return (
    <Paper style={defaultEditorPopoverPaperStyles}>
      {showCompletedPopover ? (
        <CompletedFieldPopoverContent inputField={field} />
      ) : (
        <IncompleteVariablePopoverContent
          fieldEntry={fieldEntry}
          variable={field}
          wasSentForSignature={getWorkflowWasSentForSig(document.workflow)}
        />
      )}
    </Paper>
  );
}
